/* eslint-disable */
import { registerBlockType } from '@wordpress/blocks';
import { TextControl, Button } from '@wordpress/components';
import './editor.css';
import './style.css';

const Edit = ( { attributes, setAttributes } ) => {
	const { urls } = attributes;

	const addUrl = () => {
		setAttributes( { urls: [ ...urls, '' ] } );
	};

	const updateUrl = ( index, value ) => {
		const newUrls = [ ...urls ];
		newUrls[ index ] = value;
		setAttributes( { urls: newUrls } );
	};

	const removeUrl = ( index ) => {
		const newUrls = urls.filter( ( _, i ) => i !== index );
		setAttributes( { urls: newUrls } );
	};

	return (
		<div>
			{ urls.map( ( url, index ) => (
				<div
					key={ index }
					style={ {
						display: 'flex',
						alignItems: 'center',
						marginBottom: '10px',
					} }
				>
					<TextControl
						value={ url }
						onChange={ ( val ) => updateUrl( index, val ) }
						placeholder="Enter app URL (App Store or Google Play)"
						style={ { flex: 1 } }
					/>
					<Button
						onClick={ () => removeUrl( index ) }
						isDestructive
						style={ { marginLeft: '10px' } }
					>
						Remove
					</Button>
				</div>
			) ) }
			<Button onClick={ addUrl } isPrimary>
				Add URL
			</Button>
		</div>
	);
};

const Save = ( { attributes } ) => {
	const { urls } = attributes;

	return (
		<div
			className="app-download-buttons"
			style={ { display: 'flex', flexWrap: 'wrap' } }
		>
			{ urls.map( ( url, index ) => {
				const isIOS = url.includes( 'apps.apple.com' ) || url.includes( 'itunes.apple.com' );
				const isAndroid = url.includes( 'play.google.com' );
				if ( ! isIOS && ! isAndroid ) return null;

				const imageSrc = isIOS
					? 'https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg'
					: 'https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg';
				const altText = isIOS
					? 'Download on the App Store'
					: 'Get it on Google Play';

				return (
					<a
						key={ index }
						href={ url }
						target="_blank"
						rel="noopener noreferrer"
						style={ { margin: '5px' } }
					>
						<img
							src={ imageSrc }
							alt={ altText }
							className={ isIOS ? 'ios-badge' : 'android-badge' }
						/>
					</a>
				);
			} ) }
		</div>
	);
};

// eslint-disable-next-line no-unused-vars
registerBlockType( 'app-download-buttons/main', {
	title: 'App Download Buttons',
	description: 'Add sortable app download buttons for iOS and Android.',
	icon: 'download',
	category: 'widgets',
	keywords: [ 'app', 'download', 'button', 'ios', 'android' ],
	attributes: {
		urls: {
			type: 'array',
			default: [],
		},
	},
	edit: Edit,
	save: Save,
} );
